/** Provider-neutral reward delivery. A resolved ad promise alone earns nothing. */
export function createRewardedCatHint({ controller, ads, setPaused, isDisposed }) {
  return ({ prepare }) => {
    if (typeof ads?.showRewarded !== "function") return Promise.resolve(false);
    let open = true;
    let credited = false;
    let received = false;
    const finish = () => {
      open = false;
      setPaused(false);
      return credited;
    };
    setPaused(true);
    try {
      prepare();
      // Call immediately within the user's click; each adapter verifies its own
      // completion signal before invoking the shared onReward callback.
      const request = ads.showRewarded({ placement: "cat-hint", onReward() {
        if (!open || received || isDisposed()) return;
        received = true;
        credited = controller.creditRewardedCatHint();
      } });
      return Promise.resolve(request).then(finish, finish);
    } catch {
      return Promise.resolve(finish());
    }
  };
}
